import { APCOA_EI_TENANT_IDS } from '@debbie/common/dist/bespoke/apcoa/index.js';
import keys from '@debbie/common/dist/cache/keys.js';
import { CaseVoucherSource, hasWriteOffAmounts, } from '@debbie/common/dist/economy/case-vouchers/index.js';
import { isPastExpiry } from '@debbie/common/dist/economy/helpers/expiration.js';
import { getVoucherLabel, isListed, isPayment, isStruckThrough, } from '@debbie/common/dist/economy/helpers/vouchers.js';
import { VoucherCategory, } from '@debbie/common/dist/economy/vouchers/index.js';
import { ExpiringVoucherCategories } from '@debbie/common/dist/economy/vouchers/setup.js';
import { Site, formatNumber } from '@debbie/common/dist/index.js';
import { useBillingVouchers } from '@debbie/cortex/dist/billing-vouchers/index.js';
import { caseVouchersEntity } from '@debbie/cortex/dist/case-vouchers/index.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import q from '@debbie/cortex/dist/query.js';
import { useTenant, useTenantId } from '@debbie/cortex/dist/tenant/index.js';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../../theme.js';
import APCOAFeeCard from '../../bespoke/APCOA/APCOAFeeCard.js';
import { Col, Row } from '../../Grid/index.js';
import AlertTriangle from '../../Icons/AlertTriangle.js';
import AssociationIcon from '../../Icons/AssociationIcon.js';
import CornerDownRight from '../../Icons/CornerDownRight.js';
import FileIcon from '../../Icons/File.js';
import GitMerge from '../../Icons/GitMerge.js';
import Info from '../../Icons/Info.js';
import XCircle from '../../Icons/XCircle.js';
import { CopyToClipboard, Modal } from '../../index.js';
import CaseVoucherInfo from './CaseVoucherInfo.js';
import PaymentTypeComponent from './PaymentType.js';
import VoucherAmount from './VoucherAmount.js';
const Voucher = (props) => {
    const { singleCase } = props;
    const site = useSelector((s) => s.site);
    const lang = useSelector((s) => s.lang);
    // Engine 2 writes off parts of a voucher: the row is struck through only
    // when nothing is left to show, and the icons give what was written off,
    // except to debtors, who see nothing of expiry. Only a row with nothing
    // left gets the expiry cross, so a partly expired row shows none.
    const writtenOff = hasWriteOffAmounts(props.caseVoucher);
    const shownWrittenOff = (amount) => site === Site.Debtor ? 0 : (amount ?? 0);
    const expiredAmount = shownWrittenOff(props.caseVoucher.expiredAmount);
    const irrecoverableAmount = shownWrittenOff(props.caseVoucher.irrecoverableAmount);
    const tenant = useTenant();
    const creditorLoadable = useCreditor(singleCase?.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const [infoModalOpen, setInfoModalOpen] = useState(false);
    const onMouseIn = () => {
        if (isPayment(props.caseVoucher)) {
            props.setDepositCaseVoucherHovored(props.caseVoucher.caseVoucherId);
        }
    };
    const onMouseOut = () => {
        if (isPayment(props.caseVoucher)) {
            props.setDepositCaseVoucherHovored(null);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(VoucherStyled, { parent: props.parent != null ? props.parent : false, small: props.small != null ? props.small : false, level: props.level, onMouseEnter: onMouseIn, onMouseLeave: onMouseOut },
            props.depositCaseVoucherHovored && (React.createElement(BillingTip, { caseId: props.singleCase.caseId, caseVoucherId: props.caseVoucher.caseVoucherId, depositCaseVoucherId: props.depositCaseVoucherHovored })),
            isStruckThrough(props.caseVoucher) && (React.createElement(InvalidVoucherStrikethrough, { parent: props.parent != null ? props.parent : false, small: props.small != null ? props.small : false, level: props.level })),
            React.createElement(VoucherMeta, null,
                site !== Site.Debtor && (React.createElement(Info, { style: {
                        marginRight: props.small ? '0.9em' : '.5em',
                        cursor: 'pointer',
                        userSelect: 'none',
                    }, onClick: () => {
                        setInfoModalOpen(true);
                    } })),
                props.child && (React.createElement(CornerDownRight, { style: {
                        margin: '-0.1em 0.3em 0 0.3em',
                    } })),
                React.createElement("p", { style: {
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    } },
                    getVoucherLabel(props.caseVoucher, lang),
                    props.caseVoucher.interest
                        ? ` ${parseFloat((props.caseVoucher.interest * 100).toFixed(3))} %`
                        : null,
                    ' ',
                    props.caseVoucher.appendix && (React.createElement(FileIcon, { style: {
                            height: '0.8em',
                            width: '0.8em',
                            margin: '0.1em 0.3em -0.1em 0.1em',
                        } })),
                    props.caseVoucher.referenceId ? (React.createElement("small", { style: {
                            maxWidth: '120px',
                            display: 'inline-block',
                            verticalAlign: 'middle',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }, title: props.caseVoucher.referenceId },
                        React.createElement(CopyToClipboard, { text: props.caseVoucher.referenceId, hideIcon: true }, props.caseVoucher.referenceId))) : (''),
                    ' ',
                    props.caseVoucher.source === CaseVoucherSource.Creditor &&
                        site !== Site.Debtor && (React.createElement(GitMerge, { style: {
                            transform: 'rotate(-90deg)',
                            margin: '0.1em 0 -0.1em',
                        }, "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.economy.imposedByCreditor })),
                    ' ',
                    props.caseVoucher.associationId && site !== Site.Debtor && (React.createElement(AssociationIcon, { style: { margin: '0.1em 0 -0.1em' }, "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.associateCases.associateCase })),
                    ' ',
                    props.caseVoucher.paymentType && (React.createElement(PaymentTypeComponent, { paymentType: props.caseVoucher.paymentType })))),
            creditor && (React.createElement(CategoryInfo, null,
                React.createElement("span", { style: {
                        position: 'absolute',
                        right: props.parent || props.small ? '100px' : '100px',
                    } },
                    site === Site.Caseworker &&
                        ExpiringVoucherCategories.includes(props.caseVoucher.category) &&
                        !props.caseVoucher.expired &&
                        props.caseVoucher.expirationDate != null &&
                        tenant !== null &&
                        isPastExpiry(props.caseVoucher.expirationDate, tenant.timezone) && (React.createElement(AlertTriangle, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.economy.debtExpied, style: { margin: '0.2em 0.2em -0.1em' } })),
                    (writtenOff
                        ? !isListed(props.caseVoucher) && expiredAmount > 0
                        : props.caseVoucher.expired) && (React.createElement(XCircle, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": writtenOff
                            ? `${lang.economy.debtExpied}: ${formatNumber(expiredAmount)}`
                            : lang.economy.debtExpied, style: {
                            margin: '0.2em 0.2em -0.1em',
                            color: 'red',
                            opacity: '0.6',
                        } })),
                    (writtenOff
                        ? irrecoverableAmount > 0
                        : props.caseVoucher.irrecoverableDate) && (React.createElement(AlertTriangle, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": writtenOff
                            ? `${lang.economy.debtIrrecoverable}: ${formatNumber(irrecoverableAmount)}`
                            : lang.economy.debtIrrecoverable, style: {
                            margin: '0.2em 0.2em -0.1em',
                            color: 'red',
                            opacity: '0.6',
                        } })),
                    moment(props.caseVoucher.date).format(THEME.DATE_FORMAT_SHORT)),
                React.createElement(VoucherAmount, { caseVoucher: props.caseVoucher, color: props.caseVoucher.category === 'transaction' })))),
        infoModalOpen ? (React.createElement(CaseVoucherInfoModal, { caseVoucher: props.caseVoucher, setInfoModalOpen: setInfoModalOpen, caseVouchers: props.caseVouchers, singleCase: singleCase })) : null,
        props.caseVoucher.children &&
            props.caseVoucher.children
                .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
                .map((childVoucher) => (React.createElement(Voucher, { level: props.level, deletable: props.deletable, small: true, category: props.category, caseVouchers: props.caseVouchers, caseVoucher: { ...childVoucher, children: [] }, parent: false, child: true, key: childVoucher.caseVoucherId, caseId: props.caseId, singleCase: singleCase, depositCaseVoucherHovored: props.depositCaseVoucherHovored, setDepositCaseVoucherHovored: props.setDepositCaseVoucherHovored })))));
};
export default Voucher;
const BillingTip = (props) => {
    const billingVouchersLoader = useBillingVouchers(props.caseId);
    const billingVouchers = h.hasData(billingVouchersLoader)
        ? billingVouchersLoader.data
        : null;
    const relatedBillingVouchers = billingVouchers &&
        billingVouchers.filter((billingVoucher) => {
            const isThisCaseBillingVoucher = billingVoucher.caseVoucherId === props.caseVoucherId;
            const isThisDepositCaseBillingVoucher = billingVoucher.depositCaseVoucherId === props.depositCaseVoucherId;
            const isVat = billingVoucher.category === VoucherCategory.VAT;
            return (isThisCaseBillingVoucher && !isVat && isThisDepositCaseBillingVoucher);
        });
    if (!relatedBillingVouchers?.length) {
        return null;
    }
    return (React.createElement(StyledBillingTip, null,
        React.createElement("p", null,
            relatedBillingVouchers.map((billingVoucher, index) => {
                let join = '';
                if (index != 0) {
                    if (billingVoucher.amount > 0) {
                        join = ' + ';
                    }
                    else {
                        join = ' - ';
                    }
                }
                const isFee = [
                    VoucherCategory.COLLECTIONCOMMISSION,
                    VoucherCategory.FEE,
                ].includes(billingVoucher.category);
                return (React.createElement("span", { key: billingVoucher.billingVoucherId },
                    join,
                    React.createElement("span", { style: {
                            color: isFee ? THEME.SUCCESS : undefined,
                            fontWeight: isFee ? 900 : undefined,
                            textDecoration: billingVoucher.billingId
                                ? undefined
                                : 'underline',
                        }, key: billingVoucher.billingVoucherId },
                        formatNumber(Math.abs(billingVoucher.amount)),
                        ' ',
                        React.createElement("span", { style: { fontSize: '.8em' } },
                            "(",
                            moment(billingVoucher.date).format(THEME.DATE_FORMAT_SHORT),
                            ")"))));
            }),
            relatedBillingVouchers.length > 1 && (React.createElement(React.Fragment, null,
                ' ',
                "=",
                ' ',
                formatNumber(relatedBillingVouchers.reduce((acc, billingVoucher) => billingVoucher.amount + acc, 0)))))));
};
const CaseVoucherInfoModal = (props) => {
    const { setInfoModalOpen, caseVoucher, caseVouchers, singleCase } = props;
    const lang = useSelector((s) => s.lang);
    const tenantId = useTenantId();
    const parkingModuleActive = tenantId &&
        APCOA_EI_TENANT_IDS.includes(tenantId) &&
        caseVoucher.category === VoucherCategory.PRINCIPAL;
    return (React.createElement(Modal, { header: React.createElement(React.Fragment, null,
            React.createElement(CopyToClipboard, { text: props.caseVoucher.caseVoucherId, hideIcon: true },
                lang.economyVoucherTypeLabels[props.caseVoucher.voucherTypeId] || props.caseVoucher.label,
                ' ',
                props.caseVoucher.referenceId),
            ' ',
            "-",
            ' ',
            React.createElement(CopyToClipboard, { text: `${props.caseVoucher.id}` }, props.caseVoucher.id)), maxWidth: parkingModuleActive
            ? '1600px'
            : isPayment(props.caseVoucher)
                ? undefined
                : '800px', onToggle: () => setInfoModalOpen(false) }, parkingModuleActive ? (React.createElement(Row, null,
        React.createElement(Col, { width: "3" },
            React.createElement(CaseVoucherInfo, { caseVoucher: caseVoucher, caseVouchers: caseVouchers, onDeleteVoucher: () => {
                    setInfoModalOpen(false);
                    q.invalidate(keys.write.modify(caseVouchersEntity, caseVoucher.caseVoucherId));
                }, singleCase: singleCase })),
        React.createElement(Col, { width: "9" },
            React.createElement(APCOAFeeCard, { caseVoucher: caseVoucher })))) : (React.createElement(CaseVoucherInfo, { caseVoucher: caseVoucher, caseVouchers: caseVouchers, onDeleteVoucher: () => {
            setInfoModalOpen(false);
            q.invalidate(keys.write.modify(caseVouchersEntity, caseVoucher.caseVoucherId));
        }, singleCase: singleCase }))));
};
const VoucherStyled = styled.div `
  display: flex;
  position: relative;
  justify-content: space-between;
  align-items: center;
  padding: ${(props) => props.small
    ? '0em 0 0.5em 0.1em'
    : props.parent
        ? '0.5em 0 0.25em 0em'
        : '0.25em 0 0.25em 0em'};
  font-size: ${(props) => (props.small ? '0.8em' : '1em')};

  & p {
    margin: 0;
  }

  ${(props) => (props.level === 1 ? '' : '')}
`;
const CategoryInfo = styled.div `
  display: flex;
  align-items: center;
`;
const VoucherMeta = styled.div `
  display: flex;
  align-items: center;
  max-width: calc(100% - 155px);
`;
const InvalidVoucherStrikethrough = styled.span `
  position: absolute;
  width: calc(100% - 26px);
  right: 0;
  height: 1px;
  background-color: black;
  opacity: 40%;
`;
const StyledBillingTip = styled.div `
  position: absolute;
  left: calc(100% + 10px);
  background-color: white;
  border: 1px solid lightgrey;
  border-radius: 3px;
  padding: 2px 5px;
  font-size: 0.9em;
  width: max-content;
  z-index: 9;
`;
//# sourceMappingURL=Voucher.js.map